export enum CompanyMedicType {
    yes = 'YES',
    no = 'NO',
    unknown = 'UNKNOWN',
}
